import * as React from 'react';
import settings from './settings.json';
import { getMenuIcon } from './helper.js';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import MenuDetail from './MenuDetail.js';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

function MenuAsList({ section }) {
  const [currentMenuItem, setCurrentMenuItem] = React.useState(false);
  const menuItems = settings.menuItems.filter(m => m.sectionSlug === section.slug);
  const clickMenuItem = (item) => {
    return currentMenuItem === item ? setCurrentMenuItem(false) : setCurrentMenuItem(item);
  }
  const MenuItem = (menuItem, index) => (
    <Box sx={{borderBottom: '1px dotted white'}}>
    <ListItem key={index} disablePadding variant="h6" sx={{justifyContent: 'space-between', alignItems:'center'}}>
      <ListItemButton onClick={(e) => clickMenuItem(menuItem)}>
        <ListItemIcon>
          {currentMenuItem === menuItem ? <ExpandLessIcon sx={{color: 'white'}} /> : getMenuIcon(menuItem.sectionSlug)}
        </ListItemIcon>
        <ListItemText primary={menuItem.itemNumber && menuItem.itemNumber > 0 ? menuItem.itemNumber+". "+menuItem.title : menuItem.title} />
        <ListItemText sx={{textAlign:'right', paddingRight:"16px", overflow:"visible", whiteSpace: "nowrap"}} primary={"$ "+menuItem.price.toFixed(2)} />
      </ListItemButton>
    </ListItem>
    {(currentMenuItem == menuItem) && (<MenuDetail menuItem={menuItem} showImage={menuItem.sectionSlug=="entrees"} />)}
    </Box>
  );
  return (
    <div className="menuAsList">
      <List
        direction="row"
        sx={{ alignItems: 'center' }}
      >
      {menuItems.map(MenuItem)}
      </List>
    </div>
  );
};
export default MenuAsList;
